import { ProductControllerSearchSourcesEnum } from "definitions/product-storage";
import { DewuLogo, GoatLogo, PoizonComLogo } from "src/components";

import { VariantTreeDto } from "./components/ProductContent/VariantTreeDto";

export const PRICE_CONFIRM_KEY = "price_request_confirmed";

export const SIZE_ATTR_NAME = "Размер";

export const platforms = [
  {
    label: "DEWU",
    value: ProductControllerSearchSourcesEnum.Dewu,
    icon: DewuLogo,
  },
  {
    label: "POIZON",
    value: ProductControllerSearchSourcesEnum.Poizon,
    icon: PoizonComLogo,
  },
  {
    label: "GOAT",
    value: ProductControllerSearchSourcesEnum.Goat,
    icon: GoatLogo,
  },
];

export enum priceCurrency {
  CNY = "CNY",
  RUB = "RUB",
  USD = "USD",
}

export type PlatformType = (typeof platforms)[number];

const BLUR_SIZES = ["42", "43", "44", "45"];

export const BLUR_VARIANTS: VariantTreeDto = {
  attributes: {
    [SIZE_ATTR_NAME]: BLUR_SIZES,
  },
  variants: Object.fromEntries(
    BLUR_SIZES.map((size) => [
      `${SIZE_ATTR_NAME}=${size}`,
      {
        skuId: 0,
        prices: [
          {
            price: 0,
            currency: priceCurrency.RUB,
            delivery: { min: null, max: null },
          },
        ],
      },
    ]),
  ),
};

export const BLUR_PRICE = {
  price: 25990,
  currency: "RUB",
  delivery: "≈ 25–30 дней",
};
